module.exports = __webpack_public_path__ + "media/images/landing/ar/save_time@2x-083fd50202f5e37da72f1d5985382c46.png";